import React from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { sidebarActions } from '../../../store/admin/sidebar';
import SidebarProfile from './sidebar-profile';
import SidebarNav from './sidebar-nav';

const Sidebar = props => {
    return (
        <React.Fragment>
            <div id="sidebar" className={'sidebar ' + (props.pageSidebarTransparent ? 'sidebar-transparent' : '')} >
                <div className="{overflow-scroll-temp height-full"> 
                    <SidebarProfile />
                    <SidebarNav />
                    <Link to="#!" className="sidebar-minify-btn" onClick={props.handleSetPageSidebarMinified}>
                        <i className="fa fa-angle-double-left"></i>
                    </Link>
                </div>
            </div>
            <div className="sidebar-bg"></div>
            <div className="sidebar-mobile-dismiss" onClick={props.handleSetPageSidebarToggled}></div>
        </React.Fragment>
    )
}

export default connect(
    state => state.sidebar,
    dispatch => bindActionCreators(sidebarActions, dispatch)
)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/admin/sidebar/sidebar.js